<div
  [class]="'uploader-dropzone' + (disabled ? ' disabled' : '')"
  [class.drag-over]="isDragOver"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="!disabled ? fileInput.click() : null"
>
  <input
    #fileInput
    type="file"
    [multiple]="multiple"
    [accept]="accept"
    (change)="onFileSelected($event)"
  />
  <mat-icon class="material-symbols-outlined upload-icon">cloud_upload</mat-icon>
  <span class="title">{{ title }}</span>
  <span class="subtitle">{{ subtitle }}</span>
  <span class="hint">{{ hint }}</span>
</div>

<div class="files-list" *ngIf="files.length > 0">
  <div class="file-item" *ngFor="let file of files; let i = index">
    <div class="file-info">
      <mat-icon class="material-symbols-outlined file-icon">
        {{ getFileIcon(file.name) }}
      </mat-icon>
      <div class="file-details">
        <span class="file-name">{{ file.name }}</span>
        <span class="file-size">{{ getFileSize(file.size) }}</span>
      </div>
      <button
        type="button"
        class="remove-file-btn"
        (click)="removeFile(i)"
        aria-label="Remove file"
      >
        <mat-icon class="material-symbols-outlined remove-icon">close</mat-icon>
      </button>
    </div>
  </div>
</div>

<div class="file-error" *ngIf="showFileTypeErrorMessage">
  {{ 'form.upload_file.errors.supported_types' | translate }}
</div>
